import Signup from "./Signup.jsx";

export default Signup;
